import { AnyAction, Reducer } from "redux";

import { EngagementPhase, SessionState } from "./definitions";
import {
    ACTION_CHANGE_ENGAGEMENT_PHASE,
    ACTION_CHANGE_EXPANDED_STATUS,
    ACTION_START_SESSION,
    ACTION_UPDATE_SESSION_DATA,
    ACTION_UPDATE_PRE_ENGAGEMENT_DATA,
    ACTION_UPDATE_PRE_ENGAGEMENT_FIELD_VALUE,
    ACTION_UPDATE_SYNC_MAP_ITEM_DATA
} from "./actions/actionTypes";

const initialState: SessionState = {
    currentPhase: EngagementPhase.Loading,
    expanded: false,
    preEngagementData: {
        name: "",
        query: "",
        email: ""
    }
};

export const SessionReducer: Reducer<SessionState, AnyAction> = (
    state: SessionState = initialState,
    action: AnyAction
): SessionState => {
    switch (action.type) {
        case ACTION_START_SESSION: {
            return {
                ...state,
                token: action.payload.token,
                conversationSid: action.payload.conversationSid,
                currentPhase: action.payload.currentPhase,
                syncMap: action.payload.syncMap
            };
        }

        case ACTION_UPDATE_SESSION_DATA: {
            return {
                ...state,
                token: action.payload.token,
                conversationSid: action.payload.conversationSid
            };
        }

        case ACTION_CHANGE_EXPANDED_STATUS: {
            return {
                ...state,
                expanded: action.payload.expanded
            };
        }

        case ACTION_CHANGE_ENGAGEMENT_PHASE: {
            return {
                ...state,
                currentPhase: action.payload.currentPhase
            };
        }

        case ACTION_UPDATE_PRE_ENGAGEMENT_DATA: {
            return {
                ...state,
                preEngagementData: {
                    ...state.preEngagementData,
                    ...action.payload.preEngagementData
                }
            };
        }

        case ACTION_UPDATE_PRE_ENGAGEMENT_FIELD_VALUE: {
            return {
                ...state,
                preEngagementData: {
                    name: state.preEngagementData?.name ?? "",
                    query: state.preEngagementData?.query ?? "",
                    email: state.preEngagementData?.email ?? "",
                    fields: {
                        ...state.preEngagementData?.fields,
                        [action.payload.key]: action.payload.value
                    }
                }
            };
        }

        case ACTION_UPDATE_SYNC_MAP_ITEM_DATA: {
            return {
                ...state,
                syncMapItemData: action.payload.syncMapItemData
            };
        }

        default:
            return state;
    }
};
